import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';
import { setQueryParams } from '@/utils/query-params';
import { resolveBaseUrlAndClubName } from '@/utils/url';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: { name: 'Page', params: { path: undefined } },
    },
    {
        path: '/:path*',
        name: 'Page',
        component: () => import('@/components/global/Page.vue'),
    },
];

const { base, clubName } = resolveBaseUrlAndClubName();

const router = new VueRouter({
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            };
        }

        return { x: 0, y: 0 };
    },
    mode: 'history',
    base,
    routes,
});

router.beforeEach((to, from, next) => {
    // Check if path has a trailing slash, if found remove it; skip for home ('/')
    if (to.path && to.path !== '/' && to.path.slice(-1) === '/') return next({ ...to, path: to.path.slice(0, -1) });

    const currentClubName = store.state.clubName;

    if (clubName !== currentClubName) {
        store.dispatch('setClubName', { clubName });
    }

    next();
});

setQueryParams(router, ['affiliate', 'reference']);

export default router;
